import { createAsyncThunk } from '@reduxjs/toolkit';

import ERRORS from '~/constants/errors';

import { selectPolicyData } from '../selectors/selectPolicyData';
import { selectQuote } from '../selectors/selectQuote';
import { quotesApi } from '../services/quotes';
import { decline } from '../slices/decline';
import { updateAccessToken, updateQuoteNumber } from '../slices/quote';
import { AppDispatch, RootState } from '../store';
import { GoalEvents } from '../types/analytics';
import { PolicyBuilderMode, PolicyResponse } from '../types/policy';
import { qalTrackEventAction } from './analytics';

export const saveQuoteAction = createAsyncThunk<
  PolicyResponse,
  undefined,
  {
    state: RootState;
    dispatch: AppDispatch;
  }
>('saveQuoteAction', async (_, { dispatch, getState }) => {
  const { quoteNumber, accessToken } = selectQuote(getState());
  const policyData = selectPolicyData(getState(), {
    issueDocument: true,
    includeAccessToken: true,
    mode: PolicyBuilderMode.Quote,
  });
  let quoteData: PolicyResponse;
  if (quoteNumber && accessToken) {
    quoteData = await dispatch(
      quotesApi.endpoints?.updateQuote.initiate({
        quoteNumber,
        policyData,
      })
    ).unwrap();
  } else {
    quoteData = await dispatch(quotesApi.endpoints.saveQuote.initiate(policyData)).unwrap();
  }
  const qNumber = quoteData?.policy?.policyHeader?.policyTransactionInformation?.policyNumber;
  const accToken = quoteData?.policy?.customerParty?.accessToken;
  if (!qNumber) {
    dispatch(decline(ERRORS.quoteNumberNotFound));
  } else if (!accToken) {
    dispatch(decline(ERRORS.accessTokenNotFound));
  } else {
    dispatch(updateQuoteNumber(qNumber));
    dispatch(updateAccessToken(accToken));
    dispatch(
      qalTrackEventAction({
        event: 'submit',
        eventAction: 'email quote success',
        eventLabel: 'save quote',
      })
    );
    dispatch(
      qalTrackEventAction({
        event: GoalEvents.EmailQuote,
        eventAction: 'email quote',
        eventLabel: qNumber,
      })
    );
  }
  return quoteData;
});
